import React from "react";
import { Row, Col, Card } from "antd";
import "./index.css";
import coverProfile from "../../assets/images/login-bg.jpg";
import profile from "../../assets/images/rider.png";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";

import { MdModeEditOutline } from "react-icons/all";
const CoverImage = ({
  userImage,
  CoverImage,
  onChangeCoverImage,
  onChangeProfileImage,
  keyTab,
  onChangeBusinessImage,
  isShowEditCoverImage,
  isShowProfileIcon,
  isShowProfileName,
}) => {
  let profileImageRef;
  let coverImageRef;
  console.log("user_image==>", userImage);

  return (
    <Row justify="center">
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={24}
        style={{ marginBottom: "10px" }}
      >
        <Row>
          <Col
            span={24}
            className="rmx-reg-profile-cover"
            style={{
              backgroundImage: `url(${CoverImage})`,
            }}
          >
            <Row>
              <Col
                xl={4}
                lg={4}
                md={4}
                xs={6}
                sm={12}
                className="rmx-reg-profile-img-container"
                style={{ right: "-2%" }}
              >
                <Col
                  xl={24}
                  lg={24}
                  className="rmx-reg-circle-profile-image"
                  id="preview-logo"
                  style={{
                    backgroundImage: `url(${userImage})`,
                  }}
                >
                </Col>
              </Col>
              <Col
                xl={20}
                xxl={20}
                lg={20}
                md={20}
                sm={20}
                xs={20}
                style={{
                  height: "40vh",
                  position: "relative",
                }}
              >
                {/* <Row align="bottom" justify="start" className="logistic-profile-name-container">
                  <Col span={24} >
                    {!isShowProfileName && (
                      <Row>
                        <Col
                          style={{ textAlign: 'left' }}
                          xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}
                          className={keyTab == "2" ? "logistic-profile-keyTab2 white-text text-left" : "logistic-profile-keyTab1   white-text text-left "}
                        >
                          <h3 id="logistic-profile-name">
                            {keyTab === "2" ||
                              ("3" &&
                                ` Hello, ${userImage?.first_name} ${userImage?.last_name}!`)}
                          </h3>
                        </Col>
                      </Row>

                    )}
                  </Col>
                </Row> */}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <input
        type="file"
        ref={(ref) => (profileImageRef = ref)}
        className="d-none"
        onChange={(e) => {
          keyTab == "2" ? onChangeBusinessImage(e) : onChangeProfileImage(e);
        }}
      />
      <input
        type="file"
        ref={(ref) => (coverImageRef = ref)}
        className="d-none"
        onChange={(e) => {
          onChangeCoverImage(e, userImage);
        }}
      />
    </Row>
  );
};
export default CoverImage;
